import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PublicationsService } from './../../../services/publications/publications.service';

@Component({
  selector: 'app-publication-details',
  templateUrl: './publication-details.component.html',
  styleUrls: ['./publication-details.component.scss']
})
export class PublicationDetailsComponent implements OnInit {

  token:string;
  post:any = {};

  constructor(
    private publicationsService:PublicationsService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    this.token = this.route.snapshot.paramMap.get("token");
    this.getPost();
  }

  getPost(){
    this.publicationsService.getPostDetails(this.token).subscribe(post => {
      this.post = post;
    })
  }

}
